module.exports = __webpack_public_path__ + "img/maze_octagonal_c.cd595ecd.svg";